<!-- 选择班级-多选 -->
<template>
  <el-form-item :label="label">
    <el-select v-model="classMultiple" :multiple="config.multiple === false ? false : true" filterable remote
      reserve-keyword collapse-tags-tooltip fit-input-width :collapse-tags="true" :max-collapse-tags="1" clearable
      automatic-dropdown :placeholder="config.placeholder" :remote-method="remoteMethod" :loading="loading"
      @visible-change="clearClassData">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        <span :class="item.classStatus === 1 ? 'option-label' : ''"
          :title="item.label.length > 7 ? item.label : undefined">{{
            item.label }}</span>
        <span style="float:right;color:#a8abb2;font-size: 13px;" v-if="item.classStatus === 1">(已结班)</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref } from 'vue';

export default {
  kind: 'yq-支持多选班级',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ([]),
    },
    queryParams: {
      type: Object,
      default() {
        return {};
      },
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '班级：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    const api = inject('api');
    const loading = ref(false);
    function reset() {
      // eslint-disable-next-line no-use-before-define
      classMultiple.value = props.value;
    }
    const options = ref([]);
    const remoteMethod = async (query) => {
      loading.value = true;
      const { data } = await api.queryClassList({
        className: query,
        classStatus: !props.queryParams.classStatusList && props.config.all ? undefined : 0,
        ...props.queryParams,
        page: { pageNum: 0, pageSize: 100 },
      }).finally(() => {
        loading.value = false;
      });
      options.value = data.map((v) => ({ label: v.className, value: v.id, classStatus: v.classStatus }))
        .sort((a, b) => a.classStatus - b.classStatus);
    };
    remoteMethod('');
    const clearClassData = (val) => {
      if (!val) {
        remoteMethod('');
      }
    };
    const classMultiple = useQuery('class-values', props.value, reset);

    if (props.value.id) {
      onMounted(() => {
        child.value.setField(props.value.name);
      });
    }

    return {
      child,
      reset,
      classMultiple,
      loading,
      remoteMethod,
      clearClassData,
      options,
    };
  },
};
</script>
<style>
.option-label {
  display: inline-block;
  width: 120px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
